import {
  createKpiTileItem,
  formatPercentageValue,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { percentOfSkuReduction, percentOfSkuReductionDelta } =
      data.getPOReachMetrics;

    return createKpiTileItem(
      '% of SKU Reduction',
      formatPercentageValue(percentOfSkuReduction),
      percentOfSkuReductionDelta !== null &&
        percentOfSkuReductionDelta !== undefined
        ? {
            isPositiveValue: percentOfSkuReductionDelta >= 0,
            text: formatPercentageValue(Math.abs(percentOfSkuReductionDelta)),
            sideLabel: '',
            showArrow: Number(percentOfSkuReductionDelta) !== 0,
          }
        : null
    );
  },
};
